import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import MuiTabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import SendIcon from "@mui/icons-material/Send";
import AssessmentIcon from "@mui/icons-material/Assessment";

import BulkSmsPanel from "./BulkSmsPanel";
import BulkSmsReport from "./BulkSmsReport";

const BulkSmsContainer = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "calc(100vh - 4rem)", overflow: "hidden" }}>
      <MuiTabs
        value={tabValue}
        onChange={(_, v) => setTabValue(v)}
        sx={{
          borderBottom: "1px solid var(--color-gray-selected)",
          flexShrink: 0,
          "& .MuiTab-root": {
            textTransform: "none",
            fontSize: "15px",
            fontWeight: "normal",
            color: "var(--color-solid)",
            "&.Mui-selected": {
              color: "var(--color-primary-surface)",
              fontWeight: 500,
            },
          },
        }}
        TabIndicatorProps={{
          sx: { backgroundColor: "var(--color-link)", height: "3px" },
        }}
      >
        <Tab icon={<SendIcon sx={{ fontSize: 18 }} />} iconPosition="start" label={t("sendSmsTab")} />
        <Tab icon={<AssessmentIcon sx={{ fontSize: 18 }} />} iconPosition="start" label={t("smsReports")} />
      </MuiTabs>

      <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
        {tabValue === 0 && <BulkSmsPanel />}
        {tabValue === 1 && <BulkSmsReport />}
      </Box>
    </Box>
  );
};

export default BulkSmsContainer;
